"use strict";
/*
 * Created on 16.02.2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * @author MSu
 */


var WindowProductDetails =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(WindowProductDetails, _DomainObject_1$Domai);

  // tslint:disable-next-line:prettier
  function WindowProductDetails(windowId, windowItemId, productId) {
    var _this;

    _classCallCheck(this, WindowProductDetails);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowProductDetails).call(this));
    _this.windowId = windowId;
    _this.windowItemId = windowItemId;
    _this.productId = productId;
    return _this;
  }

  return WindowProductDetails;
}(DomainObject_1.DomainObject);

exports.WindowProductDetails = WindowProductDetails;